import { QueryKey } from "@tanstack/react-query";
import React from "react";

import { useQuerySearchRevisionNotes } from "@examspark/common-app";

import Browse, { FilterData } from "../../components/browse/Browse";
import RevisionNoteList from "../../components/browse/RevisionNoteList";
import {
  filterDataToSearchableResourceFilterInput,
  useFilterQueryParam,
} from "../../components/browse/useSearch";

const defaultSearchFilter: FilterData = {
  grade: [],
  subject: "",
  query: "",
};

const RevisionRoute = () => {
  const [searchFilter, setSearchFilter] =
    useFilterQueryParam(defaultSearchFilter);

  const useSearch = (props?: { queryKey?: QueryKey; filter?: FilterData }) => {
    const filter = filterDataToSearchableResourceFilterInput({
      filter: props?.filter ?? {},
      baseFilter: {},
    });

    const result = useQuerySearchRevisionNotes({
      queryKey: props?.queryKey ?? ["revision-notes", searchFilter],
      filter,
    });
    return {
      ...result,
      updateResults: () => {
        // this isn't necessary since we don't have favorites.
        // but the types can't quite handle us not having it at all
      },
    };
  };

  return (
    <Browse
      pageTitle="Browse TEKS RS Revision Notes"
      resultList={RevisionNoteList}
      withFilters={{
        subject: true,
        grade: true,
        type: false,
        query: false,
        objectives: false,
      }}
      useSearchFn={useSearch}
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
      onFilterClear={() => {
        setSearchFilter(defaultSearchFilter);
      }}
    />
  );
};

export default RevisionRoute;
